import { render } from "./ModelParameterFields.vue?vue&type=template&id=3b30ab6d"
import script from "./ModelParameterFields.vue?vue&type=script&lang=js"
export * from "./ModelParameterFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__